var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.user.profile_image_url)?[_c('img',{staticClass:"u-user-avatar-initial",class:_vm.sizeClass,attrs:{"src":_vm.user.profile_image_url}})]:[_c('i',{staticClass:"u-user-avatar-initial",class:_vm.sizeClass,style:(_vm.initialIconStyle)},[_vm._v(_vm._s(_vm.user.last_name_initial))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }